export default "__VITE_ASSET__BrRytVNl__"